import { defineMessages } from 'react-intl';

export default defineMessages({
    FirstName: {
        id: 'quoteandbind.residential.additionalInsured.First Name',
        defaultMessage: 'First Name',
    },
    LastName: {
        id: 'quoteandbind.residential.additionalInsured.Last Name',
        defaultMessage: 'Last Name',
    },
    saveFailedMsg: {
        id: 'quoteandbind.residential.additionalInsured.Save failed, please try again',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'quoteandbind.residential.additionalInsured.Can\'t Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },

});
